import { BaseModel } from "sjs-base-model";
import ProductOrder from "./ProductOrder";

export default class ProductModel extends BaseModel {
    id = "";
    name = "";
    description = "";
    category = "";
    subcategory = "";
    venue = [];
    isFilterableProduct = false;
    order = new ProductOrder();
    upsellingProducts = [];
    excludedCountries = [];
    visible = false;
    useCaseCategoryId = null;

    constructor(data) {
        super();
        this.update(data);
    }
}